import { useState } from 'react';
import PropTypes from 'prop-types';

import { LOCATION_CONFIG } from 'apps/web_forms/utils/constants';
import { getCurrentPosition } from 'apps/web_forms/utils/locationHelpers';

const { defaultLat, defaultLng } = LOCATION_CONFIG;

const useLocation = () => {
  const [defaultCenter] = useState({ lat: defaultLat, lng: defaultLng });
  const [positionInfo, setPositionInfo] = useState();
  const [locationError, setLocationError] = useState(false);
  const [center, setCenter] = useState();
  const [locationStrings, setLocationStrings] = useState();

  const clearLocation = () => {
    setPositionInfo('');
    setLocationError(false);
    setCenter();
    setLocationStrings({});
  };

  const changePosition = ({
    lat,
    lng,
    altitude,
    accuracy,
    altitudeAccuracy,
  }) => {
    const shortString = `lat=${lat}, long=${lng}`;
    const string = `lat=${lat}, long=${lng}, alt=${altitude}, hAccuracy=${accuracy}, vAccuracy=${altitudeAccuracy}, timestamp=${new Date().toISOString()}`;
    const newPositionInfo = `Lat: ${lat} | Lon: ${lng} ${
      accuracy ? `| Accuracy: ${accuracy} m` : ''
    }`;

    setCenter({ lat, lng });
    setPositionInfo(newPositionInfo);
    setLocationStrings({ shortString, string, position: newPositionInfo });

    setLocationError(false);
  };

  const setUserAccuracy = async () => {
    setPositionInfo(`Loading current location`);
    try {
      const coords = await getCurrentPosition();
      changePosition({
        ...coords,
        lat: coords.latitude,
        lng: coords.longitude,
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Location error: ', err);
      setPositionInfo('Location unavailable');
      setLocationError(true);
    }
  };

  const getUserAccuracy = async () => {
    return getCurrentPosition();
  };

  return {
    defaultCenter,
    center,
    positionInfo,
    locationError,
    locationStrings,
    changePosition,
    setUserAccuracy,
    clearLocation,
    getUserAccuracy,
  };
};

useLocation.propTypes = {
  element: PropTypes.shape({
    identifier: PropTypes.string,
  }).isRequired,
};

export default useLocation;
